module.exports = __webpack_public_path__ + "static/media/language2.ed8e3f4e.png";